import React from "react";
import { Alert } from "antd";
import LoadingIndicator from "../shared/LoadingIndicator/LoadingIndicator";

const TrackedKeywordsCount = ({ isLoading, keywordsCount, maxKeywordsNo, push }) => {
  return (
    <div className="tracked-keywords-count">
      {isLoading ? (
        <LoadingIndicator />
      ) : (
        <Alert
          message={
            <p style={{ marginTop: "1em" }}>
              You are using {keywordsCount} out of {maxKeywordsNo} maximum keywords limit for all your websites. If you
              need more keywords, please consider to: <strong><span className="fake-link" onClick={()=>push("/subscription/plans")}>Upgrade your plan</span></strong>
            </p>
          }
        />
      )}
    </div>
  );
};

export default TrackedKeywordsCount;
